/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigSetting } from '../../models/config-setting';

export interface ConfigSettingGetCarefinityTransaction$Params {
  id?: number;
  practiceId?: string | null;
}

export function configSettingGetCarefinityTransaction(http: HttpClient, rootUrl: string, params?: ConfigSettingGetCarefinityTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigSetting>> {
  const rb = new RequestBuilder(rootUrl, configSettingGetCarefinityTransaction.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('practiceId', params.practiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigSetting>;
    })
  );
}

configSettingGetCarefinityTransaction.PATH = '/configsetting/getconfigsetting';
